<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-07-31 11:36:17
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-04 17:37:54
-->
<template>
  <div>
    <div class="type">
      <el-tabs v-model="activeName" class="type-style" type="card" @tab-click="handleClick">
        <el-tab-pane v-if="codeData.indexOf('410') != -1"  label="报备记录" name="first"></el-tab-pane>
        <el-tab-pane v-if="codeData.indexOf('411') != -1"  label="报备查看" name="second"></el-tab-pane>
        <el-tab-pane  v-if="codeData.indexOf('423') != -1 || codeData.indexOf('422') != -1"  label="报备统计" name="third"></el-tab-pane>
      </el-tabs>
      <record  v-if="type == 1 && codeData.indexOf('410') != -1"></record>
      <viewDeil  v-if="type == 2 && codeData.indexOf('411') != -1"></viewDeil>
      <statistics    v-if="type == 3 && (codeData.indexOf('423') != -1 || codeData.indexOf('422') != -1)"></statistics>
    </div>
  </div>
</template>

<script>
import record from './components/record.vue';
import viewDeil from './components/view.vue';
import statistics from './components/statistics.vue';
export default {
  data(){
    return {
      type:1,
      codeData:[],
      activeName:'first',
    }
  },
  components:{
   record,
   viewDeil,
   statistics

  },
  mounted(){
      this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
      if(this.codeData.indexOf('410') == -1 && this.codeData.indexOf('411') == -1){
          this.type = 3;
          this.activeName = 'third'
      }else if(this.codeData.indexOf('410') == -1){
           this.type = 2;
          this.activeName = 'second'
      }
  },
    methods:{
    handleClick(){
        if(this.activeName == 'first'){
            this.type = 1;
        }
         if(this.activeName == 'second'){
            this.type = 2;
        }
         if(this.activeName == 'third'){
            this.type = 3;
        }
      }
    }
}
</script>

<style lang="less" scoped>
  .log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;
  .log {
    padding: 10px 20px;
    border-top: solid 2px #dcdfe6;
    border-left: solid 2px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 2px #dcdfe6;
  }
  .log:last-child {
    border-right: solid 2px #dcdfe6;
    border-top-right-radius: 10px;
  }
  .log:first-child {
    border-top-left-radius: 10px;
  }
}
.dir {
  height: 2px;
  background: #dcdfe6;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: -2px;
}
.type-style{
  padding: 24px;
  padding-bottom: 6px;
}
/deep/ .box .search{
   padding: 0px 24px 0px 24px;
}
/deep/ .el-tabs__item.is-active{
    color: #176DE6;
}
/deep/ .el-tabs__item{
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  font-family: Roboto;
}
.push-box {
            width: 8px;
            height: 8px;
            background-color: rgba(245, 108, 108, 1);
            text-align: center;
            border-radius: 50%;
            position: absolute;
            right: 10px;
            top: 10px;
          }
</style>